import type { ColDef, ValueGetterParams } from 'ag-grid-enterprise';
import type { ProjectLogEntry } from '../../services/timeEntryService';
import { agGridCSSClasses } from '../../theme/agGridTheme';
import { TaskCellRenderer } from './TaskCellRenderer';

export const createColumnDefinitions = (
  ActionCellRenderer: any,
  selectedDate: Date,
  onEdit: (entry: ProjectLogEntry) => void,
  onDelete: (id: string) => void,
  disabled?: boolean,
  actualHours?: number,
  plannedHours?: number,
  projectLoggedHours?: ProjectLogEntry[]
): ColDef<ProjectLogEntry>[] => [
  {
    headerName: 'Project',
    valueGetter: (params: ValueGetterParams<ProjectLogEntry>) => {
      const project = params.data?.project_info;
      if (!project) return '';
      return `${project.project_number}_${project.project_name}`;
    },
    width: 180,
    minWidth: 150,
    maxWidth: 200,
    pinned: 'left',
    lockPosition: 'left',
    headerClass: agGridCSSClasses.modernHeader,
    cellClass: agGridCSSClasses.modernCell,
  },
  {
    headerName: 'Order No',
    valueGetter: (params: ValueGetterParams<ProjectLogEntry>) => {
      const order = params.data?.order_info;
      if (!order) return '';
      return `${order.order_number}_${order.comments}`;
    },
    width: 180,
    minWidth: 150,
    maxWidth: 200,
    pinned: 'left',
    lockPosition: 'left',
    headerClass: agGridCSSClasses.modernHeader,
    cellClass: agGridCSSClasses.modernCell,
  },
  {
    headerName: 'Task',
    cellRenderer: TaskCellRenderer,
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    pinned: 'left',
    lockPosition: 'left',
    headerClass: agGridCSSClasses.modernHeader,
    cellClass: agGridCSSClasses.modernCell,
    autoHeight: true,
  },
  {
    headerName: 'Work Type',
    field: 'work_type',
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    headerClass: agGridCSSClasses.modernHeader,
    cellClass: agGridCSSClasses.modernCell,
    valueFormatter: (params: any) => {
      if (!params.value) return '';
      return params.value.toUpperCase();
    },
  },
  {
    headerName: 'Description',
    field: 'description',
    wrapText: true,
    autoHeight: true,
    flex: 1,
    minWidth: 180,
    headerClass: agGridCSSClasses.modernHeader,
    cellClass: agGridCSSClasses.modernCell,
    editable: !disabled,
  },
  {
    headerName: 'Hours',
    field: 'hours_logged',
    width: 100,
    minWidth: 80,
    maxWidth: 120,
    pinned: 'right',
    lockPosition: 'right',
    headerClass: agGridCSSClasses.modernHeader,
    cellClass: agGridCSSClasses.modernCell,
    editable: !disabled,
    valueFormatter: (params: any) => {
      if (params.value === null || params.value === undefined) return '';
      return typeof params.value === 'number' ? params.value.toFixed(2) : params.value;
    },
    valueParser: (params: any) => {
      const value = Number.parseFloat(params.newValue);
      return Number.isNaN(value) ? 0 : value;
    },
  },
  {
    headerName: 'Actions',
    width: 200,
    minWidth: 180,
    maxWidth: 220,
    pinned: 'right',
    lockPosition: 'right',
    cellRenderer: ActionCellRenderer,
    cellRendererParams: {
      selectedDate,
      onEdit,
      onDelete,
      disabled,
      actualHours,
      plannedHours,
      projectLoggedHours,
    },
    cellClass: agGridCSSClasses.actionCell,
    headerClass: agGridCSSClasses.modernHeader,
    sortable: false,
    filter: false,
    editable: false,
  },
];
